export default "__VITE_ASSET__BWWb9kzu__"